import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import Loading from '../widgets/Loading'
import BackButton from '../controls/BackButton'
import CollapsibleSections from '../controls/CollapsibleSections'

import TopNav from '../widgets/common/TopNav'
import Auth from '../auth/Auth'

// redux
import { fetchFAQs } from '../redux/actions/faqActions'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class FAQ extends Component {
  constructor () {
    super()
    this.collapseStatus = this.collapseStatus.bind(this)
    this.state = {}
  }

  collapseStatus (id, state) {
    this.setState({
      currentSection: id,
      expanded: state
    })
  }

  componentDidMount () {
    const lang = this.props.intl.locale
    this.props.fetchFAQs(lang)
  }

  render () {
    // determine the header
    const header = Auth.isAuthenticated ? <Header /> : <TopNav primary />
    const { faqs = [] } = this.props

    const getContentElement = (item, key) => {
      return (
        <React.Fragment>
          <div id={`content${key}`} dangerouslySetInnerHTML={{ __html: item.answer }} />
          {item.img ? <div><img src={item.img} alt={item.alt} /></div> : null}
        </React.Fragment>
      )
    }

    const collapsibleSectionItems = faqs.length > 0 && faqs.reduce((items, nextItem) => {
      if (nextItem.question && nextItem.answer) {
        const faqItem = {
          heading: nextItem.question,
          secondaryHeading: undefined,
          content: getContentElement(nextItem, nextItem.id)
        }
        return [...items, faqItem]
      } else {
        return [...items]
      }
    }, [])

    // create the main content for page
    // get the class names to use fo rmain content
    const mcClasses = Auth.isAuthenticated ? 'mainContent ' : 'faqUnAuthContent'
    const backButton = !Auth.isAuthenticated ? <div><BackButton label={localize('common.back')} /></div> : null
    const mainContent = <section className={mcClasses} >
      <Grid fluid>
        <Row>
          <Col xs={12} lgOffset={1} lg={10} style={{ minHeight: 'calc(100vh)' }}>
            {backButton}
            <h4 className='sectionHeading'>{localize('pages.faq.title')}</h4>
            {collapsibleSectionItems.length > 0
              ? <CollapsibleSections items={collapsibleSectionItems} />
              : <div >
                <Loading message={localize('common.loadingContent')} />
              </div>}
          </Col>
        </Row>
      </Grid>
      <Footer />
    </section>

    // create the page content
    const pageContent = <div className={Auth.isAuthenticated ? 'pageContent' : null}>
      {header}
      {mainContent}
    </div>

    // return the page content
    return pageContent
  }
}

function mapStateToProps (state, ownProps) {
  return {
    faqs: state.FAQReducer.faqs || [],
    error: state.FAQReducer.error,
    isLoading: state.FAQReducer.isLoading
  }
}
const ConnectedFAQ = connect(mapStateToProps, { fetchFAQs })(injectIntl(FAQ))
export default ConnectedFAQ



// WEBPACK FOOTER //
// ./src/components/FAQ.js